import BaseService from "./BaseService";

const endpoint = 'tennants';

class TennantService {
  static async GetTennants(token, id = null, params = {}) {
      const url = id ? `${endpoint}/${id}` : endpoint;

      const response = await BaseService.get(url, token, params);

      return response.data;
  }

  static async CreateTennant(token, tennant) {
      const response = await BaseService.post(endpoint, tennant, token);

      return response.data;
  }

  static async UpdateTennant(token, id, tennant) {
    const response = await BaseService.put(endpoint, id, tennant, token);

    return response.data;
  }

  static async DeleteTennant(token, id) {
    const response = await BaseService.delete(endpoint, id, token);

    return response.data;
  }
}

export default TennantService;